import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEdit } from '../../assets/icons';
import { DialogConfirmation } from '../dialog/confirmation';
import { Header } from '../header';
import { InputMui } from '../input-mui/input-mui';
import { SliderHorizontal } from '../slider-horizontal';

type InputSliderDialogProps = {
  value: number | null;
  handleSaveValue: (value: number | null) => void;
  unit: string;
  dialogTitle: string;
  headerTitle?: string;
  inputLabel?: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  noBottomMargin?: boolean;
  reverse?: boolean;
  maxWidth?: boolean;
  errorMessage?: string;
};

export const InputSliderDialog: React.FC<InputSliderDialogProps> = ({
  handleSaveValue,
  value,
  unit,
  dialogTitle,
  min,
  max,
  step,
  headerTitle,
  inputLabel,
  disabled = false,
  noBottomMargin = false,
  reverse,
  maxWidth,
  errorMessage,
}) => {
  const { t: tc } = useTranslation('common');
  const [tempValue, setTempValue] = useState<number | null>(null);
  const [showPicker, setShowPicker] = useState<boolean>(false);

  useEffect(() => {
    if (value != null) setTempValue(value);
  }, [value, showPicker]);

  const handleCloseDialog = () => {
    setShowPicker(false);
    setTempValue(null);
  };

  return (
    <>
      {headerTitle && <Header title={headerTitle} className="m-b-16" />}
      <div style={{ width: '100%' }} {...(maxWidth ? { className: 'grid-list-24' } : {})}>
        <InputMui
          value={value != null ? `${value}${unit}` : ''}
          readOnly
          endIcon={<IconEdit />}
          reverse={reverse}
          disabled={disabled}
          onClickInput={() => setShowPicker(true)}
          {...(inputLabel && { label: inputLabel })}
          {...(errorMessage ? { errorMessage } : {})}
          {...(noBottomMargin && { sx: { marginBottom: 0 } })}
        />
      </div>
      <DialogConfirmation
        show={showPicker}
        setShow={handleCloseDialog}
        header={dialogTitle}
        headerValue={tempValue != null ? `${tempValue}${unit}` : `-${unit}`}
        primaryBtnText={tc('buttons.save')}
        secondaryBtnText={tc('buttons.cancel')}
        primaryBtnAction={() => {
          handleSaveValue(tempValue);
          setShowPicker(false);
        }}
        secondaryBtnAction={handleCloseDialog}
        contentClassName="p-r-0 p-l-0"
      >
        <SliderHorizontal
          defaultValue={tempValue || 0}
          value={tempValue || 0}
          {...(min !== undefined ? { min } : {})}
          {...(max !== undefined ? { max } : {})}
          {...(step !== undefined ? { step } : {})}
          onChange={(_, value) => {
            setTempValue(value as number);
          }}
        />
      </DialogConfirmation>
    </>
  );
};
